<template>
  <path pid="0" d="M13.94 3.15a1 1 0 00-1.88 0l-7 19a1 1 0 001.44 1.22l6.5-3.72 6.5 3.72a1 1 0 001.44-1.22zm-.44 14.48a1 1 0 00-1 0l-4.61 2.64L13 6.39l5.11 13.88z"/>
</template>
